import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { goToCheckout } from '../lib/constants';
/**
 * Persuasive sticky CTA bar. Appears after the user scrolls past the hero so
 * cold Meta Ads traffic always has a one-tap path to checkout. Routes to the
 * Shopify cart via goToCheckout() — no manual Meta events fired.
 */
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-228">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-purple/10 bg-white/90 px-4 py-3 backdrop-blur-md shadow-[0_-8px_30px_-12px_rgba(30,20,70,0.25)]" data-id="element-229">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-4" data-id="element-230">
            <div className="hidden sm:block" data-id="element-231">
              <p className="text-sm font-semibold text-gray-900" data-id="element-232">
                Protocolo Antibloqueo del Terapeuta™
              </p>
              <p className="text-xs text-gray-500" data-id="element-233">
                <span className="text-gray-400 line-through" data-id="element-234">US$97</span>{' '}
                <span className="font-bold text-green-600" data-id="element-235">US$10.99 hoy</span> ·
                Acceso inmediato
              </p>
            </div>
            <button type="button" onClick={goToCheckout} className="cta-pulse w-full rounded-4xl bg-brand-purple px-6 py-3.5 text-base font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-[#4b32bd] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-lila/50 sm:w-auto" data-id="element-236">
              👉 QUIERO EL SISTEMA AHORA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}